import { ElementType, FC } from 'react';
import { Box, BoxProps, Text } from '@chakra-ui/react';
import { CbLink } from '../CbLink';
import { RewardsActivityCardType, TransactionTypes, SourceType } from '../../types/RewardsActivityCard';
import { formatNumber, pluralize } from '../../helpers/numbers';
export interface CbRewardsActivityCardTitleProps extends BoxProps {
  amount: RewardsActivityCardType['amount'];
  source: RewardsActivityCardType['source'];
  purchaseInformation: RewardsActivityCardType['purchaseInformation'];
  titleHref?: string;
  titleAs?: ElementType;
  transactionType: RewardsActivityCardType['transactionType'];
}
export const CbRewardsActivityCardTitle: FC<CbRewardsActivityCardTitleProps> = ({
  amount = 0,
  source,
  titleHref,
  titleAs,
  transactionType,
  purchaseInformation,
  ...props
}) => {
  const tokenAmount = <Text as="span" fontWeight="bold">{`${formatNumber(Math.abs(amount))} ${pluralize(amount, 'Token')}`}</Text>;
  const boldText = (text: string) => <Text as="span" fontWeight="bold" data-sentry-element="Text" data-sentry-component="boldText" data-sentry-source-file="CbRewardsActivityCardTitle.tsx">
        {text}
      </Text>;
  const link = (text: string) => titleHref ? <CbLink as={titleAs} href={titleHref} fontWeight="bold" textDecoration="underline">
          {text}
        </CbLink> : boldText(text);
  const getReceivedFrom = () => {
    if (source?.type === SourceType.Chest || source?.type === SourceType.LootBox) {
      return boldText('Chest');
    } else return link(source?.name);
  };
  const getTextByTransaction = () => {
    switch (transactionType) {
      case TransactionTypes.TokensReceived:
        return <>
              {tokenAmount}
              {' received from '}
              {getReceivedFrom()}
            </>;
      case TransactionTypes.StorePurchase:
        return <>
              {!!purchaseInformation?.denomination && boldText(`${purchaseInformation.denomination} `)}
              {boldText(source?.name)}
              {' Purchased'}
            </>;
      case TransactionTypes.ChestReceived:
        return <>
              {boldText('Chest')}
              {' received from '}
              {link(source?.name || 'Game')}
            </>;
      case TransactionTypes.TokensGiven:
        return <>
              {tokenAmount}
              {' sent to '}
              {link(source?.name)}
            </>;
      case TransactionTypes.TokensRemoved:
        return <>
              {tokenAmount}
              {' removed by '}
              {boldText(source?.name)}
            </>;
      default:
        return <>{tokenAmount}</>;
    }
  };
  return <Box color="text.primary" {...props} data-sentry-element="Box" data-sentry-component="CbRewardsActivityCardTitle" data-sentry-source-file="CbRewardsActivityCardTitle.tsx">
        <Text data-sentry-element="Text" data-sentry-source-file="CbRewardsActivityCardTitle.tsx">{getTextByTransaction()}</Text>
        {!!purchaseInformation?.fee && purchaseInformation.fee > 0 && <Text fontSize={'sm'} color="red">
            {`- $${purchaseInformation.fee} fee`}
          </Text>}
      </Box>;
};